import React from 'react';
import { View, TouchableOpacity, Text, StyleSheet, ActivityIndicator } from 'react-native';
import CloseIcon from '../assets/svg/CloseIcon';

const styles = StyleSheet.create({
  popupContainer: {
    backgroundColor: '#000000aa',
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    justifyContent: 'center',
  },
  popupbox: {
    alignSelf: 'center',
    justifyContent: 'center',
    height: 200,
    width: 400,
    backgroundColor: '#fff',
  },
  popupText: {
    fontFamily: 'PingFangSC-Regular',
    color: '#555559',
    alignSelf: 'center',
    fontSize: 20,
  },
  popupCloseIcon: {
    top: 6,
    right: 6,
    height: 25,
    width: 25,
    position: 'absolute',
  },
  activityIndicator: {
    alignSelf: 'center',
  },
});

interface Props {
  handleClosePopup: () => void;
  text: string;
  isLoading: boolean;
}

const Popup: React.FunctionComponent<Props> = ({ handleClosePopup, text, isLoading }) => {
  return (
    <View style={styles.popupContainer}>
      <View style={styles.popupbox}>
        <TouchableOpacity style={styles.popupCloseIcon} onPress={handleClosePopup}>
          <CloseIcon />
        </TouchableOpacity>
        {isLoading ? (
          <ActivityIndicator style={styles.activityIndicator} />
        ) : (
          <Text style={styles.popupText}>{text}</Text>
        )}
      </View>
    </View>
  );
};

export default React.memo(Popup);
